import { get } from "lodash";
export const replaceBracedComponents = (input, config) => input.replace(/\{([^}]+)\}/g, (_, key) => get(config, key.replace(/::/g, ".")));
